import { api } from './client';

// Ответ при создании ключа (содержит сам ключ - показывается один раз!)
export interface ApiKeyCreatedResponse {
  id: string;
  name: string;
  keyPrefix: string;
  key: string; // Полный ключ - показывается ТОЛЬКО при создании!
  createdAt: string;
}

// Ответ при получении списка ключей (без самого ключа)
export interface ApiKeyListItem {
  id: string;
  name: string;
  keyPrefix: string;
  lastUsedAt: string | null;
  createdAt: string;
  revokedAt: string | null;
}

export interface CreateApiKeyDto {
  name: string;
}

export const apiKeysApi = {
  /**
   * Получить список своих API ключей
   */
  getMyKeys: async (): Promise<ApiKeyListItem[]> => {
    const { data } = await api.get('/api-keys');
    return data;
  },

  /**
   * Создать новый API ключ
   * Возвращает полный ключ ОДИН РАЗ - потом его нельзя получить!
   */
  create: async (dto: CreateApiKeyDto): Promise<ApiKeyCreatedResponse> => {
    const { data } = await api.post('/api-keys', dto);
    return data;
  },

  /**
   * Отозвать (деактивировать) ключ
   */
  revoke: async (id: string): Promise<void> => {
    await api.delete(`/api-keys/${id}`);
  },
};
